// src/data/twoPieceStyles.js
// Tile images live in: public/assets/styles/t1.jpg ... t6.jpg
// Detail media lives in: src/assets/samples/t1/*, t2/*, ... (01.jpg, 02.jpg, 01.mp4 ...)

export const TWO_PIECE_STYLES = [
  { id: "t1", slug: "t1", name: "T1", img: "/assets/styles/t1.jpg", blurb: "Classic flat faced 5-spoke with a lip" },
  { id: "t2", slug: "t2", name: "T2", img: "/assets/styles/t2.jpg", blurb: "Modern split sharp 5-spoke." },
  { id: "t3", slug: "t3", name: "T3", img: "/assets/styles/t3.jpg", blurb: "Lightweight 10-spoke motorsport aesthetic." },
  { id: "t4", slug: "t4", name: "T4", img: "/assets/styles/t4.jpg", blurb: "Clean face with floating-hardware look." },
  { id: "t5", slug: "t5", name: "T5", img: "/assets/styles/t5.jpg", blurb: "Deep lip with exposed hardware—aggressive stance." },
  { id: "t6", slug: "t6", name: "T6", img: "/assets/styles/t6.jpg", blurb: "Y-split silhouette with step-lip profile." },
];
